import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon';
import { KEYCODE } from '../util';
import ConfigProvider from '../config-provider';

/** Switch */
class Switch extends React.Component {
  static displayName = 'Switch';

  static contextTypes = {
    prefix: PropTypes.string,
  };

  static propTypes = {
    prefix: PropTypes.string,
    rtl: PropTypes.bool,
    pure: PropTypes.bool,
    /**
     * 自定义类名
     */
    className: PropTypes.string,
    /**
     * 自定义内敛样式
     */
    style: PropTypes.object,
    /**
     * 是否在加载中
     */
    loading: PropTypes.bool,
    /**
     * 开关状态改变是触发此事件
     * @param {Boolean} checked 是否为打开状态
     * @param {Event} e DOM事件对象
     */
    onChange: PropTypes.func,
    /**
     * 开关当前的值(针对受控组件)
     */
    checked: PropTypes.bool,
    /**
     * 开关默认值 (针对非受控组件)
     */
    defaultChecked: PropTypes.bool,
    /**
     * 表示开关被禁用
     */
    disabled: PropTypes.bool,
    /**
     * switch的尺寸
     * @enumdesc 正常大小, 缩小版大小
     */
    size: PropTypes.oneOf(['medium', 'small']),
    /**
     * 鼠标点击事件
     * @param {Event} e DOM事件对象
     */
    onClick: PropTypes.func,
    /**
     * 键盘按键事件
     * @param {Event} e DOM事件对象
     */
    onKeyDown: PropTypes.func,
  };

  static defaultProps = {
    prefix: 'next-',
    loading: false,
    disabled: false,
    size: 'medium',
    defaultChecked: false,
    onChange: () => {},
  };

  constructor(props, context) {
    super(props, context);

    const checked = props.checked || props.defaultChecked;
    this.state = {
      checked,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      let { checked } = nextProps;
      if (checked === undefined) {
        checked = false;
      }
      this.setState({
        checked,
      });
    }
  }

  onChange = ev => {
    const checked = !this.state.checked;

    if (!('checked' in this.props)) {
      this.setState({
        checked,
      });
    }
    this.props.onChange(checked, ev);
    this.props.onClick && this.props.onClick(ev);
  };

  onKeyDown = e => {
    if (e.keyCode === KEYCODE.ENTER || e.keyCode === KEYCODE.SPACE) {
      this.onChange(e);
    }
    this.props.onKeyDown && this.props.onKeyDown(e);
  };

  render() {
    /* eslint-disable no-unused-vars */
    const { prefix, className, loading, disabled, size, rtl, ...others } = this.props;
    const status = this.state.checked ? 'on' : 'off';

    let _size = size;
    if (_size !== 'small' && _size !== 'medium') {
      _size = 'medium';
    }

    const classes = classNames({
      [`${prefix}switch`]: true,
      [`${prefix}switch-${status}`]: true,
      [`${prefix}switch-loading`]: loading,
      [`${prefix}switch-${_size}`]: true,
      [className]: className,
    });
    let attrs;

    if (!disabled && !loading) {
      attrs = {
        onClick: this.onChange,
        tabIndex: 0,
        onKeyDown: this.onKeyDown,
        disabled: false,
      };
    } else {
      attrs = {
        disabled: true,
      };
    }

    return (
      <div
        role="switch"
        dir={rtl ? 'rtl' : undefined}
        tabIndex="0"
        {...others}
        className={classes}
        {...attrs}
        aria-checked={this.state.checked}
      >
        {loading ? <Icon className="loading-icon" type="loading" /> : null}
      </div>
    );
  }
}

export default ConfigProvider.config(Switch);
